import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { cloneDeep } from 'lodash'

import { INIT_STRUCTURE, TABS, TABS_ARRAY, validateTabs } from './utils'
import Modal from '../../../../../../../components/Modal/Modal'
import Header from '../../../../../../../components/Modal/components/Header/Header'
import Footer from '../../../../../../../components/Modal/components/Footer/Footer'
import { FinalScreenTab } from '../../../../../../../components/ModalTabs/FinalScreenTab'
import { Playground } from './views'

import './PuzzleModal.scss'

export const PuzzleModal = ({ methods, data: { structure, colorTheme, id } }) => {
    const { t } = useTranslation()
    const [tmpStructure, setTmpStructure] = useState(cloneDeep(INIT_STRUCTURE))
    const [activeTab, setActiveTab] = useState(TABS.playground)
    const [tabsValidationResult, setTabValidationResult] = useState({
        isCurrentTab: false,
        errors: { playground: {}, finalScreen: {} },
    })

    useEffect(() => {
        if (Object.keys(structure).length) {
            setTmpStructure(cloneDeep(structure))
        }
    }, [structure])

    const onSave = async () => {
        const validationResult = validateTabs(tmpStructure, tabsValidationResult)

        if (!validationResult.hasError) {
            await methods.save({
                [id]: {
                    data: {
                        struct: validationResult.tmpStructure,
                    },
                },
            })
            onClose()
        } else {
            setTabValidationResult({ isCurrentTab: false, errors: validationResult.errors })
        }
    }

    const onClose = () => {
        methods.closeModal()
    }

    const onUpdateStructure = type => newFields => {
        setTmpStructure(prevState => {
            return {
                ...prevState,
                [type]: {
                    ...prevState[type],
                    ...newFields,
                },
            }
        })
    }

    const onChangeTab = useCallback(
        tabId => {
            const validationResult = validateTabs(tmpStructure, tabsValidationResult, activeTab)
            if (validationResult.activeTabHasError) {
                setTabValidationResult({
                    isCurrentTab: validationResult.activeTabHasError,
                    errors: { ...tabsValidationResult.errors, ...validationResult.errors },
                })
            } else {
                setTabValidationResult({
                    isCurrentTab: validationResult.activeTabHasError,
                    errors: { ...tabsValidationResult.errors, ...validationResult.errors },
                })
                setActiveTab(tabId)
            }
        },
        [tmpStructure, activeTab],
    )

    return (
        <Modal closeOnOverlayClick={false} closeOnEsc={false}>
            <Header
                title={t('Puzzle Options')}
                navItems={TABS_ARRAY}
                activeNavItemId={activeTab}
                onChangeNavItem={onChangeTab}
                onClose={onClose}
            />
            <div className="puzzle-modal-wrapper">
                <div className="puzzle-modal-wrapper__body">
                    {activeTab === TABS.playground && (
                        <Playground
                            structure={tmpStructure}
                            colorTheme={colorTheme}
                            validateErrors={tabsValidationResult.errors}
                            methods={{ ...methods, updateStructure: onUpdateStructure('playground') }}
                        />
                    )}
                    {activeTab === TABS.finalScreen && (
                        <FinalScreenTab
                            structure={tmpStructure}
                            validateErrors={tabsValidationResult.errors}
                            methods={{ ...methods, updateStructure: onUpdateStructure('finalScreen') }}
                        />
                    )}
                </div>
            </div>
            <Footer actionText={t('Save')} cancelText={t('Cancel')} onClose={onClose} onAction={onSave} />
        </Modal>
    )
}
